// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing105({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/105/250227_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/105/250227_011.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/105/250227_02.gif`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/consultInquiryButton2.png`}
      companyName="광교365리움치과병원"
      privacyMessage="개인정보수집에 동의하시는 분만 '상담 문의하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      eventDates={true}
      carrotTag={true}
    />
  );
}

export default Randing105;
